import React from 'react'
import { graphql } from 'relay-runtime'
import styled from '@emotion/styled'
import { useFragment } from 'react-relay'
import { CreativeAdvisorInsight$key } from './__generated__/CreativeAdvisorInsight.graphql'
import { theme } from '../../mui'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { useAppDispatch } from '../../state/hooks'
import {
  setCreativeDrawerData,
  setCreativeDrawerOpen,
} from '../../state/appSlice'
import { CreativeDrawerView } from './CreativeDrawer'
import ErrorIcon from '@mui/icons-material/Error'

interface CreativeAdvisorInsightProps {
  fragmentRequest: CreativeAdvisorInsight$key
}

export const creativeAdvisorInsightFragment = graphql`
  fragment CreativeAdvisorInsight on Insight {
    text
    isMet
  }
`

interface InsightIconProps {
  isMet: boolean
}

const S = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
  `,
  InsightIcon: styled.div<InsightIconProps>`
    color: ${(props) =>
      props.isMet ? theme.palette.success.dark : theme.palette.warning.light};
    font-size: 1rem;
  `,
  InsightText: styled.div`
    font-size: 0.875rem;
    margin-left: 0.5rem;
    text-wrap: normal;
    line-height: 1.5rem;
  `,
}

const CreativeAdvisorInsight = ({
  fragmentRequest,
}: CreativeAdvisorInsightProps) => {
  const insight = useFragment(creativeAdvisorInsightFragment, fragmentRequest)

  return (
    <S.Wrapper>
      <S.InsightIcon isMet={insight.isMet}>
        {insight.isMet ? <CheckCircleIcon /> : <ErrorIcon />}
      </S.InsightIcon>
      <S.InsightText>{insight.text}</S.InsightText>
    </S.Wrapper>
  )
}

export default CreativeAdvisorInsight
